import { useCallback, useEffect, useRef, useState } from 'react'
import { muteluApi } from '../services/muteluApi'
import { logPageApiCall, logPageApiError, logPageApiResult } from '../utils/apiDebugLogger'

export const usePartyStatus = (groupCode, autoRefresh = false) => {
  const [groupData, setGroupData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const intervalRef = useRef(null)
  const isFetchingRef = useRef(false)

  const fetchGroupStatus = useCallback(async () => {
    if (!groupCode || isFetchingRef.current) return
    isFetchingRef.current = true
    try {
      logPageApiCall('usePartyStatus', 'getPartyStatus', { groupCode })
      const response = await muteluApi.getPartyStatus(groupCode)
      logPageApiResult('usePartyStatus', 'getPartyStatus', response)
      setGroupData(response?.data || response || null)
      setError(null)
    } catch (err) {
      logPageApiError('usePartyStatus', 'getPartyStatus', err)
      setError(err?.message || 'Failed to fetch group status')
    } finally {
      setLoading(false)
      isFetchingRef.current = false
    }
  }, [groupCode])

  useEffect(() => {
    if (!groupCode) {
      setLoading(false)
      setGroupData(null)
      return undefined
    }

    setLoading(true)
    fetchGroupStatus()

    if (autoRefresh) {
      intervalRef.current = window.setInterval(fetchGroupStatus, 30000)
    }

    return () => {
      if (intervalRef.current) {
        window.clearInterval(intervalRef.current)
      }
    }
  }, [groupCode, autoRefresh, fetchGroupStatus])

  return {
    groupData,
    loading,
    error,
    refetch: fetchGroupStatus
  }
}

export default usePartyStatus
